import { LOGO_URL, IMG } from "../lib/assets";

export const XMark = ({ className = "w-9 h-9" }) => (
  <img src={IMG.xMark} alt="" aria-hidden="true" className={`object-contain ${className}`} />
);

export const Logo = ({ tone = "dark", compact = false }) => {
  if (LOGO_URL) {
    return <img src={LOGO_URL} alt="Project X — Make Parties Great Again" data-testid="brand-logo" className={compact ? "h-11 sm:h-12 w-auto" : "h-14 sm:h-16 w-auto"} />;
  }
  const main = tone === "dark" ? "text-[#0B0B0B]" : "text-white";
  return (
    <span className="flex items-center gap-2.5 leading-none">
      <XMark className={compact ? "w-8 h-8" : "w-10 h-10"} />
      <span className="flex flex-col">
        <span className={`font-display uppercase ${compact ? "text-lg" : "text-2xl"} ${main}`}>
          Project<span className="text-[#E10600]">X</span>
        </span>
        <span className={`font-mono-x uppercase text-[9px] tracking-[0.18em] ${main} opacity-90`}>Make Parties Great Again</span>
      </span>
    </span>
  );
};
